<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <p [innerHTML]="data.message"></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <app-rfebm-secondary-button (click)="dialogRef.close(false)">Cancelar</app-rfebm-secondary-button>
  <app-rfebm-primary-button (click)="dialogRef.close(true)">{{ data.confirmButtonText || 'Confirmar' }}</app-rfebm-primary-button>
</mat-dialog-actions>
